import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { LoadingFormat } from 'src/app/core/models/loading-format';
import { LoadingFormatService } from 'src/app/core/services/general/loading-format.service';

@Component({
  selector: 'app-loading-format-input',
  templateUrl: './loading-format-input.component.html',
  styleUrls: ['./loading-format-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: LoadingFormatInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: LoadingFormatInputComponent,
    },
  ],
})
export class LoadingFormatInputComponent {
  @Input()
  title = "Select Loading Format...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public loadingFormatsList: Array<CustomSelectOption> = [];

  constructor(
    private loadingFormatService: LoadingFormatService,
  ) {
    this.loadingFormatService
      .all()
      .subscribe((res: Array<LoadingFormat>) => {
        this.loadingFormatsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.loadingFormatsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
